'use client'

import { useState, useEffect } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

const FADE_DISTANCE = 400

type Props = {
  title: string
  clientName?: string
}

export default function ProductTitle({ title, clientName }: Props) {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 990)
    check()
    window.addEventListener('resize', check)
    return () => window.removeEventListener('resize', check)
  }, [])

  const { scrollY, scrollYProgress } = useScroll()
  const opacityStart = useTransform(scrollY, [0, isMobile ? 200 : FADE_DISTANCE], [1, 0.04], { clamp: true })
  const opacityEnd = useTransform(scrollYProgress, [0.95, 1], [1, 0], { clamp: true })
  const opacity = useTransform(
    [opacityStart, opacityEnd],
    ([a, b]) => Math.min(a as number, b as number),
  )

  return (
    <motion.h1 style={{ opacity, willChange: 'opacity' }}>
      {title}
      {clientName && <span translate='no'> × {clientName}</span>}
    </motion.h1>
  )
}
